<div class="page-header">
  @if (showBackButton()) {
    @if (useHistoryBack()) {
      <button type="button" class="page-header__back" (click)="goBack()">
        <mat-icon class="page-header__back-icon">arrow_back</mat-icon>
        @if (backIcon()) {
          <mat-icon class="page-header__back-nav-icon">{{ backIcon() }}</mat-icon>
        }
        <span class="page-header__back-label">{{ backLabel() }}</span>
      </button>
    } @else {
      <a class="page-header__back" [routerLink]="backRoute()">
        <mat-icon class="page-header__back-icon">arrow_back</mat-icon>
        @if (backIcon()) {
          <mat-icon class="page-header__back-nav-icon">{{ backIcon() }}</mat-icon>
        }
        <span class="page-header__back-label">{{ backLabel() }}</span>
      </a>
    }
  }
  <h2 class="page-header__title">{{ title() }}</h2>
  @if (subtitle()) {
    <p class="page-header__subtitle">{{ subtitle() }}</p>
  }
  <!-- Slot for complex subtitle content (conditional text, etc.) -->
  <ng-content select="[slot=subtitle]"></ng-content>
</div>
